import React from "react";
import cn from "classnames";
import Checkbox from "components/ui/Checkbox";
import RadioButton from "components/ui/RadioButton";
import "styles/components/passengers-form.scss";

const PassengersSeasonForm = ({ hasRailcard, hasJCPRailcard, passengerType, onChange }) => {
  const isRailcardDisabled = passengerType === "child";

  return (
    <div className="otrl-jp__passengers-form">
      <div className="otrl-jp__passengers-form__season">
        <div className="otrl-jp__passengers-form__row">
          <RadioButton
            name="passengerType"
            ariaLabel="Adult, 16+ years"
            label={
              <div className="otrl-jp__passengers-form__row__group">
                <span className="otrl-jp__passengers-form__row__text">Adult</span>
                <span className="otrl-jp__passengers-form__row__subtext">16+ years</span>
              </div>
            }
            onChange={onChange("passengerType")}
            selected={passengerType}
            value="adult"
          />
        </div>
        <div className="otrl-jp__passengers-form__row">
          <RadioButton
            name="passengerType"
            ariaLabel="Child, 5 to 15 years"
            label={
              <div className="otrl-jp__passengers-form__row__group">
                <span className="otrl-jp__passengers-form__row__text">Child</span>
                <span className="otrl-jp__passengers-form__row__subtext">5-15 years</span>
              </div>
            }
            onChange={onChange("passengerType")}
            selected={passengerType}
            value="child"
          />
        </div>
      </div>
      <div className="otrl-jp__passengers-form__season__subtext">
        <span className="otrl-jp__passengers-form__row__subtext">Children under 5 travel free</span>
      </div>
      <div>
        <div className="otrl-jp__passengers-form__railcard-option">
          <Checkbox
            disabled={isRailcardDisabled}
            name="hasRailcard"
            label="16/17 Saver Railcard"
            onChange={onChange("hasRailcard")}
            selected={hasRailcard}
            variant="dark"
          />
          <p
            className={cn("otrl-jp__passengers-form__railcard-text", {
              "otrl-jp__passengers-form__railcard-text--disabled": isRailcardDisabled
            })}
          >
            If you have a 16-17 Saver Railcard click above to validate it and receive discounts on
            Season tickets
          </p>
        </div>
        <div className="otrl-jp__passengers-form__railcard-option">
          <Checkbox
            disabled={isRailcardDisabled}
            name="hasJCPRailcard"
            label="Jobcentre Plus Railcard"
            onChange={onChange("hasJCPRailcard")}
            selected={hasJCPRailcard}
            variant="dark"
          />
        </div>
      </div>
    </div>
  );
};

export default PassengersSeasonForm;
